module.exports = __webpack_public_path__ + "img/executionAutomatic.092d0dcc.svg";